export default {
  'Arizona Diamondbacks': {
    displayName: 'AZ Diamondbacks',
    logoUrl: 'baseball/baseball_ARI.webp',
  },
  Athletics: {
    displayName: 'OAK Athletics',
    logoUrl: 'baseball/baseball_OAK.webp',
  },
  'Atlanta Braves': {
    displayName: 'ATL Braves',
    logoUrl: 'baseball/baseball_ATL.webp',
  },
  'Baltimore Orioles': {
    displayName: 'BAL Orioles',
    logoUrl: 'baseball/baseball_BAL.webp',
  },
  'Boston Red Sox': {
    displayName: 'BOS Red Sox',
    logoUrl: 'baseball/baseball_BOS.webp',
  },
  'Chicago Cubs': {
    displayName: 'CHI Cubs',
    logoUrl: 'baseball/baseball_CHC.webp',
  },
  'Chicago White Sox': {
    displayName: 'CHI White Sox',
    logoUrl: 'baseball/baseball_CWS.webp',
  },
  'Cincinnati Reds': {
    displayName: 'CIN Reds',
    logoUrl: 'baseball/baseball_CIN.webp',
  },
  'Cleveland Guardians': {
    displayName: 'CLE Guardians',
    logoUrl: 'baseball/baseball_CLE.webp',
  },
  'Colorado Rockies': {
    displayName: 'COL Rockies',
    logoUrl: 'baseball/baseball_COL.webp',
  },
  'Detroit Tigers': {
    displayName: 'DET Tigers',
    logoUrl: 'baseball/baseball_DET.webp',
  },
  'Houston Astros': {
    displayName: 'HOU Astros',
    logoUrl: 'baseball/baseball_HOU.webp',
  },
  'Kansas City Royals': {
    displayName: 'KC Royals',
    logoUrl: 'baseball/baseball_KC.webp',
  },
  'Los Angeles Angels': {
    displayName: 'LAA Angels',
    logoUrl: 'baseball/baseball_LAA.webp',
  },
  'Los Angeles Dodgers': {
    displayName: 'LAD Dodgers',
    logoUrl: 'baseball/baseball_LAD.webp',
  },
  'Miami Marlins': {
    displayName: 'MIA Marlins',
    logoUrl: 'baseball/baseball_MIA.webp',
  },
  'Milwaukee Brewers': {
    displayName: 'MIL Brewers',
    logoUrl: 'baseball/baseball_MIL.webp',
  },
  'Minnesota Twins': {
    displayName: 'MIN Twins',
    logoUrl: 'baseball/baseball_MIN.webp',
  },
  'New York Mets': {
    displayName: 'NYM Mets',
    logoUrl: 'baseball/baseball_NYM.webp',
  },
  'New York Yankees': {
    displayName: 'NYY Yankees',
    logoUrl: 'baseball/baseball_NYY.webp',
  },
  'Philadelphia Phillies': {
    displayName: 'PHI Phillies',
    logoUrl: 'baseball/baseball_PHI.webp',
  },
  'Pittsburgh Pirates': {
    displayName: 'PIT Pirates',
    logoUrl: 'baseball/baseball_PIT.webp',
  },
  'San Diego Padres': {
    displayName: 'SD Padres',
    logoUrl: 'baseball/baseball_SD.webp',
  },
  'San Francisco Giants': {
    displayName: 'SF Giants',
    logoUrl: 'baseball/baseball_SF.webp',
  },
  'Seattle Mariners': {
    displayName: 'SEA Mariners',
    logoUrl: 'baseball/baseball_SEA.webp',
  },
  'St. Louis Cardinals': {
    displayName: 'STL Cardinals',
    logoUrl: 'baseball/baseball_STL.webp',
  },
  'Tampa Bay Rays': {
    displayName: 'TB Rays',
    logoUrl: 'baseball/baseball_TB.webp',
  },
  'Texas Rangers': {
    displayName: 'TEX Rangers',
    logoUrl: 'baseball/baseball_TEX.webp',
  },
  'Toronto Blue Jays': {
    displayName: 'TOR Blue Jays',
    logoUrl: 'baseball/baseball_TOR.webp',
  },
  'Washington Nationals': {
    displayName: 'WAS Nationals',
    logoUrl: 'baseball/baseball_WSH.webp',
  },
};
